<template>
	<ProjectProfitTable
		:project-id="projectId"
		:retainer-period-id="retainerPeriodId"
	/>
</template>

<script lang="ts" setup>
import { ProjectProfitTable } from '@/features/Project';
import { type RetainerPeriod, type Project } from '@/generated/graphql';

defineProps<{
	projectId: Project['id'];
	retainerPeriodId?: RetainerPeriod['id'];
}>();
</script>
